module.exports = __webpack_public_path__ + "img/battle_section1_item4.9aa8a531.png";